import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { getSplashTheme, thumbFill } from "@/lib/splashThemes";
import { SplashStage } from "./SplashStage";

/** Live, looping mini version of the real splash with a full-screen play button. */
export const SplashPreview = ({ themeId, onPlay }) => {
  const theme = getSplashTheme(themeId);
  const [loop, setLoop] = useState(0);
  useEffect(() => {
    setLoop(0);
    const t = setInterval(() => setLoop((n) => n + 1), theme.duration + 1400);
    return () => clearInterval(t);
  }, [theme.id, theme.duration]);
  return (
    <div className="splash-preview-frame group" data-testid={`splash-preview-${theme.id}`}>
      <SplashStage key={`${theme.id}-${loop}`} theme={theme} contained testId="splash-preview-stage" />
      <button type="button" onClick={onPlay} data-testid="splash-preview-play-button"
        className="absolute inset-0 z-20 grid place-items-center bg-black/0 opacity-0 transition-[opacity,background-color] duration-300 hover:bg-black/30 focus-visible:opacity-100 group-hover:opacity-100">
        <span className="flex items-center gap-2 rounded-full bg-white/95 px-5 py-2.5 text-sm font-medium text-ink shadow-xl"><Play className="h-4 w-4 fill-current" /> Play full screen</span>
      </button>
    </div>
  );
};

/** Artwork thumbnail used on the theme picker cards. */
export const SplashThumb = ({ theme }) => (
  <span className="splash-thumb" data-testid={`splash-thumb-${theme.id}`}>
    {theme.art ? <img src={theme.art} alt="" loading="lazy" draggable="false" /> : <span className="splash-thumb-navy" />}
    <span className="splash-thumb-word" style={{ backgroundImage: thumbFill(theme) }}>757 REALTY</span>
  </span>
);
